import { useEffect } from 'react';
import useBrowser from './useBrowser';

function useNoTranslate() {
  const { isFirefox } = useBrowser();

  useEffect(() => {
    if (!isFirefox) return;

    // в браузере FireFox при переводе страницы перезагружается визуально и становится неуправляемым для React
    // чтобы восстановить контроль React нужно перезагружать страницу как браузер это делает
    const handleLangChange = () => {
      window.location.reload();
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'lang') {
          handleLangChange();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
      subtree: false
    });

    return () => {
      observer.disconnect();
    };
  }, [isFirefox]);
}

export default useNoTranslate;